import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

export function useDriverInfo(driverUid) {
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    // Nullstill når sjåføren byttes, så forrige sjåførs data ikke vises under lasting.
    setState({ loading: true });
    if (!driverUid) return;
    let cancelled = false;

    getDoc(doc(db, 'publicProfiles', driverUid)).then((snap) => {
      if (cancelled) return;
      if (snap.exists()) {
        const { name, orgName, phone, tippiVerified, driverDocumented, languages } = snap.data();
        setState({
          loading: false, name, orgName, phone,
          tippiVerified: tippiVerified === true,
          documented: driverDocumented === true,
          languages: Array.isArray(languages) ? languages : [],
        });
      } else {
        setState({ loading: false });
      }
    }).catch(() => {
      if (!cancelled) setState({ loading: false });
    });

    return () => { cancelled = true; };
  }, [driverUid]);

  return state;
}
